import {BasePanelWidget} from "../../BasePanelWidget";
import {DataStore} from "../../DataStore";
import {MuNamedWidgets, MuUi} from "mu-widget/lib/MuWidget";
import {CheckboxList} from "mu-widget/lib/components/InputList";
import {layoutMultiline} from "../../customize";
import {frontRouter} from "../../FrontRouter";
import {getInitials} from "../../utils";

export class UiMenu extends BasePanelWidget
{
    // @ts-ignore
    muNamedWidget: MuNamedWidgets<{
        plans: CheckboxList,
    }>;

    // @ts-ignore
    ui: MuUi<{
        lClientData: HTMLAnchorElement,
    }>;
    beforeIndex() {
        this.muAppendContent(`
            <div class="account-info d-flex-column text-align-center">
                <div class="account-info__account-name-initials" mu="#initials"></div>
                <strong class="account-info__account-name" mu="#name"></strong>
                <em class="account-info__account-email" mu="#email"></em>
                <div>
                    <a mu="#isTrainer:@visible" href="/admin" class="btn--link">Trenér - administrace</a>            
                </div>
                <div mu="pPlans" class="text-align-left">
                    <strong>Plány</strong>
                    <div mu="plans:CheckboxList">
                    </div>
                </div>
                <div class="btn-box btn-box--expand" style="margin-top:1.5rem">
                    <span mu="bLogout" class="btn--remove">Odhlásit</span>
                    <a mu="lClientData" class="btn--primary">Moje údaje</a>
                </div>
            </div>
        `);
        this.setTitle("Můj profil");
    }

    async afterIndex() {
        const userInfo = await DataStore.get().getCurrentUser();
        const myPlans = await DataStore.get().getMyPlans();
        const initials = getInitials(userInfo.name);
        this.muBindData({
            ...userInfo,
            initials
        });
        layoutMultiline(this.muNamedWidget.plans);
        this.muNamedWidget.plans.setOptions(myPlans.map(item => ({
            text: item.name,
            value: item.id.toString(),
        })));
        this.muNamedWidget.plans.value = myPlans.filter(pl => pl.active).map(pl => pl.id.toString());
        frontRouter.prepareAnchor(this.ui.lClientData, 'clientData', {});
    }

    plans_change() {
        DataStore.get().setMyActivePlans(this.muNamedWidget.plans.value.map(s => parseInt(s)));
        //todo: reload day
    }

    async bLogout_click() {
        await DataStore.get().logout();
        document.location.reload();
        // await this.muParent.afterIndex();
    }
}